"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findSeatPrice = exports.diffEpochValidators = void 0;
var utils_1 = require("@near-js/utils");
Object.defineProperty(exports, "diffEpochValidators", { enumerable: true, get: function () { return utils_1.diffEpochValidators; } });
Object.defineProperty(exports, "findSeatPrice", { enumerable: true, get: function () { return utils_1.findSeatPrice; } });
